import { isString } from 'lib';
import { isAnEmail, isValidMobileNumber } from './validation';

export const anonymizeEmailAndMobile = (value) => {
  let mobileOrEmail;
  if (isString(value) && isAnEmail(value)) {
    const parts = value.split('@');
    let username = parts[0];
    const domain = parts[1];

    if (username.length <= 2) {
      username = username.charAt(0) + '*'.repeat(username.length - 1);
    } else if (username.length <= 4) {
      username =
        username.charAt(0) +
        '*'.repeat(username.length - 2) +
        username.charAt(username.length - 1);
    } else {
      username =
        username.slice(0, 2) +
        '*'.repeat(username.length - 4) +
        username.slice(-2);
    }

    mobileOrEmail = `${username}@${domain}`;
  } else if (isString(value) && isValidMobileNumber(value)) {
    mobileOrEmail = `${value?.substring(
      0,
      value?.length - 6
    )}****${value?.substring(value?.length - 2)}`;
  } else {
    return value;
  }

  return mobileOrEmail;
};
